module.exports = __webpack_public_path__ + "img/存量房.c25b2159.png";